import { AnalyticsOrgWeTags } from '@wetags/analytics';

export const useHasCommunicationAnalyticsFeature = () => {
  return AnalyticsOrgWeTags.useWetag('communication-analytics');
};
